import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import ReactPanZoom from 'react-image-pan-zoom-rotate';

import collections from '../../../constants/FirestoreCollections';
import { useFirebase, useFirestore } from 'react-redux-firebase';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { isEmpty, last } from 'lodash';
import axios from 'axios';
import { typeByName } from '../../../constants/Filters';

import { messagesTypes, messagesContentType } from '../../../constants/ChatMessages';
import { useMediaQuery } from '@mui/material';
import { actions } from '../../../actions';
import { useHistory } from 'react-router-dom';
import { CARRODILLA } from '../../../constants/organizations';
import useChat from '../../../hooks/useChat';
import Info from './Info';
import MessageInput from './MessageInput';
import MessagesList from './MessagesList';
import { useAssignSupportedChat } from '../../../hooks/useAssignSupportedChat';
import CustomDFMessengerChat from '../../../shared/CustomDFMessengerChat/CustomDFMessengerChat';
const gatewayUrl = process.env.REACT_APP_GATEWAY_URL;
const gupshupSubscriptionsMessageUrl = process.env.REACT_APP_GUPSHUP_SUBSCRIPTIONS_MESSAGE_URL;
const gatewayWebChatUrl = process.env.REACT_APP_GATEWAY_WEB_CHAT_URL;

const useStyles = (small, openHeader) => {
  const chatContainerHeight = openHeader ? (!small ? 212 : 156) : 122;
  return makeStyles((theme) => ({
    Chats: {
      height: small ? '100dvh' : '100%',
      display: 'flex',
      flexDirection: 'column',
      position: small ? 'fixed' : 'relative',
      top: 0,
      marginTop: small && '56px',
      overflow: 'hidden',
      width: '100%',
    },
    appBarSpacer: theme.mixins.toolbar,

    table: {
      minWidth: 650,
    },
    chatSection: {
      flex: 1,
      display: 'flex',
      boxShadow: 'none',
      maxHeight: small ? 'calc(100% - 56px)' : '100%',
    },
    chatSectionLy: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    borderRight500: {
      borderRight: '1px solid #e0e0e0',
    },
    messageArea: {
      flex: small && 1,
      paddingRight: 20,
      width: '100%',
      paddingLeft: 20,
      paddingBottom: 16,
      marginTop: openHeader ? 140 : 50,
      // maxHeight: !small && (openHeader ? 'calc(100dvh - 368px)' : 'calc(100dvh - 228px)'),
      height: '100%',
      maxHeight: `calc(100% - ${chatContainerHeight}px)`,
      overflowY: 'auto',
      bottom: '0',
      background: '#dfdfdf',
      '&::-webkit-scrollbar': {
        width: '1em',
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.2)',
      },
    },
    chatFontSize: {
      fontSize: '0.85rem !important',
    },
    notification: {
      whiteSpace: 'pre-line',
      marginLeft: 'auto',
      float: 'right',
      background: '#b1d3e3',
      color: theme.palette.black.dark,
      maxWidth: '90%',
    },
    user: {
      whiteSpace: 'pre-line',
      float: 'right',
      background: '#fff3cf',
      color: theme.palette.black.dark,
      maxWidth: '90%',
      marginLeft: 'auto',
    },
    buttonSendStop: {
      borderRadius: '25px',
      fontSize: '0.8em',
    },
    modalPaper: {
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      '& img': {
        maxHeight: `calc(100dvh - ${theme.spacing(5)})`,
      },
    },
    closeButton: {
      background: '#A6C34C',
      color: theme.palette.white.main,
      height: '30px',
      width: '35px',
      margin: '4px',
    },
    input: {
      color: theme.palette.black.dark,
      '-webkit-text-fill-color': theme.palette.black.dark,
      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 1000px #000000 inset',
        color: theme.palette.black.dark,
      },
      '&:-internal-autofill-selected': {
        color: theme.palette.black.dark,
      },
    },
    cssLabel: {
      color: theme.palette.black.dark,
      borderColor: theme.palette.black.dark,
    },
    cssFocused: {
      color: theme.palette.black.dark,
      borderColor: `red !important`,
    },
    finishButton: {
      display: small && 'none',
      position: 'absolute',
      right: '16px',
      top: '16px',
    },
    closeIcon: {
      margin: 0,
      padding: 0,
    },
    divider: {
      width: '100%',
      margin: '16px 0',
    },
  }));
};

const Chat = (props) => {
  // others (refs, hooks, etc)
  const history = useHistory();
  const firebase = useFirebase();
  const firestore = useFirestore();
  const chat = useChat();
  const appDispatch = useDispatch();
  const organization = useSelector((state) => state.app.organization);
  const { updateChatSupportAndAssignment } = useAssignSupportedChat();

  // custom cases
  const isCarrodilla = CARRODILLA.includes(organization.id);
  // use states
  // eslint-disable-next-line no-unused-vars
  const [autoStop, setAutoStop] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [userMode, setUserMode] = useState(false);
  const [sending, setSending] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [unsubscribers, setUnsubscribers] = useState([]);
  const [isOlderChat, setIsOlderChat] = useState(false);
  const [oldChat, setOldChat] = useState();

  const openHeader = useSelector((state) => state.app.openSection.header);

  // define styles
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small, openHeader)();

  // selectors
  const profile = useSelector((state) => state.firebase.profile);
  const chatId = useSelector((state) => state.app.activeChat);
  const showChatsNoEnded = useSelector((state) => state.app.activeChatShowChatsNoEnded);
  const patientPopup = useSelector((state) => state.app.patientPopup);

  useEffect(() => {
    setShowHistory(false);
  }, [chatId]);

  useEffect(() => {
    if (patientPopup && patientPopup.submit) {
      handleSendMessage(null, 'DEV SIGNUP', true);
      setUserMode(true);

      appDispatch({
        type: actions.message,
        message: patientPopup.message,
      });
      appDispatch({
        type: actions.openPatientPopup,
        patientPopup: { open: false, initProcess: false, submit: false, message: '' },
      });
    }
  }, [patientPopup, patientPopup.submit]);

  const processChats = (arr) => {
    let index = 0;
    const newArr = [];
    for (const message of arr) {
      if (index !== 0) {
        const messageDate = new Date(message.creationDate.seconds * 1000);
        const lastDate = new Date(arr[index - 1].creationDate.seconds * 1000);
        if (Math.abs(messageDate.getDate() - lastDate.getDate()) >= 1) {
          newArr.push({
            messageDate,
            lastDate,
            isDivider: true,
          });
        }
      }
      newArr.push(message);
      index++;
    }
    return newArr;
  };

  let allMessages = [];
  allMessages = chat && chat.messages;
  if (!showChatsNoEnded && !isOlderChat) {
    allMessages = oldChat ? [...oldChat.messages, ...chat.messages] : allMessages;
  }
  allMessages = (allMessages && allMessages.filter((e) => e.message !== 'imagen recibida')) || [];
  allMessages = processChats(allMessages);

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const searchOldChat = () => {
    if (organization.id && chatId && chat && chat.client && chat.client.phone) {
      let promise = firestore
        .collection(collections.chats)
        .where('client.phone', '==', chat.client.phone)
        .where('type', '==', 1)
        .where('organizationId', '==', organization.id)
        .orderBy('updatedAt', 'desc');
      if (!showHistory) promise = promise.limit(2);
      promise.get().then((res) => {
        const chats = [];
        res.forEach((e) => {
          if (e) {
            chats.push({ id: e.id, ...e.data() });
          }
        });
        if (showHistory) {
          if (chats.length > 1) {
            const _chat = { ...chats[1] };
            chats.slice(2).forEach((chat, index) => {
              _chat.messages = [...chat.messages, ..._chat.messages];
            });
            setOldChat(_chat);
          } else {
            if (oldChat) setOldChat(null);
          }
        } else {
          if (chats.length === 2 && chatId !== chats[1].id) {
            setOldChat(chats[1]);
          } else {
            if (oldChat) setOldChat(null);
          }
        }
      });
    } else {
      if (oldChat) setOldChat(null);
    }
  };

  const clearReduxData = () => {
    appDispatch({
      type: actions.clear,
    });
  };

  const handleSendMessage = async (event, defaultMessage = '', defaultUserMode) => {
    if (!profile.email) {
      return firebase.logout().then(() => {
        clearReduxData();
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: `Hubo un error con su cuenta, inicie sesion nuevamente`,
            snackbarSeverity: 'error',
          },
        });
        history.push('/');
      });
    }
    appDispatch({
      type: actions.lastUpdate,
      lastUpdate: new Date(),
    });

    if (isEmpty(defaultMessage) || (isOlderChat && !isCarrodilla)) return;

    setSending(true);

    appDispatch({
      type: actions.message,
      message: '',
    });
    const formData = new FormData();
    try {
      if (defaultUserMode || userMode) {
        if (chat.type === typeByName.web) {
          formData.append(
            'body',
            JSON.stringify({
              organizationId: profile.organizationId,
              query: { message: defaultMessage, type: 'text' },
              session: last(chat.session.split('/')),
              email: profile.email,
            }),
          );
          await sendMessage(gatewayWebChatUrl, formData, {
            'Content-Type': 'multipart/form-data',
          });
          // TODO: show loader
        } else if (
          chat.type === typeByName.whatsapp &&
          organization?.provider?.name === 'gupshup'
        ) {
          const gupshupMessage = {
            type: 'message',
            email: profile.email,
            app: organization.provider.appName,
            payload: {
              source: chat.client.phone,
              type: 'text',
              payload: { text: defaultMessage, url: '' },
            },
          };
          await sendMessage(gupshupSubscriptionsMessageUrl, gupshupMessage);
        }
      } else {
        // stop bot if needed
        if (!chat.botStopped && autoStop) {
          await firestore
            .collection(collections.chats)
            .doc(chatId)
            .update({
              botStopped: true,
              stoppedHistory: firestore.FieldValue.arrayUnion({
                user: profile.email,
                date: new Date(),
              }),
            });
        }
        if (chat.type === typeByName.web) {
          await firestore
            .collection(collections.chats)
            .doc(chatId)
            .update({
              messages: firestore.FieldValue.arrayUnion({
                message: `*[operador]*\n${defaultMessage}`,
                creationDate: firestore.Timestamp.fromDate(new Date()),
                type: messagesTypes.user,
                contentType: messagesContentType.chat,
                email: profile.email,
              }),
            });
        } else if (chat.type === typeByName.whatsapp) {
          const gatewayMessage = {
            to: chat.client.phone,
            provider: organization.provider,
            message: `*[operador]*\n${defaultMessage}`,
            organizationId: profile.organizationId,
            email: profile.email,
          };
          await sendMessage(gatewayUrl, gatewayMessage);
        } else {
          throw new Error(`chat response for type ${chat.type} is unexpected`);
        }
        await updateChatSupportAndAssignment({ chatId, chat });
      }
    } catch (error) {
      console.error('handleSendMessage', error);
      appDispatch({
        type: actions.alert,
        alert: {
          snackbarOpen: true,
          snackbarMessage: defaultMessage,
          snackbarSeverity: 'error',
        },
      });
    } finally {
      !defaultUserMode && setUserMode(false);
      setSending(false);
    }

    // TODO: await updateChatSupportAndAssignment({ chatId, chat }); Si lo colocamos aca contabilizamos mensajes enviados como paciente, plantillas y DEV SIGNUP
  };

  const sendMessage = async (url, data, headers = { 'Content-Type': 'application/json' }) => {
    try {
      await axios.post(url, data, { headers });
    } catch (error) {
      console.error('sendMessage', error);
    }
  };

  // use effects
  useEffect(() => {
    setAutoStop(false);
  }, [chatId]);

  useEffect(() => {
    if (unsubscribers.length > 1) {
      unsubscribers.forEach((uns, index) => {
        if (uns && index !== unsubscribers.length - 1) {
          uns();
        }
      });
      setUnsubscribers([unsubscribers[unsubscribers.length - 1]]);
    }
  }, [unsubscribers]);

  useEffect(() => {
    if (showChatsNoEnded) {
      setOldChat(null);
    }
  }, [showChatsNoEnded]);

  useEffect(() => {
    if (organization.id && chat) {
      if (!oldChat || chatId !== chat.id) {
        searchOldChat();
      }
    } else {
      if (oldChat) setOldChat(null);
    }
  }, [organization.id, chatId, chat]);

  useEffect(() => {
    searchOldChat();
  }, [showHistory]);

  useEffect(() => {
    if (chat) {
      if (chat && chat.updatedAt && chat.updatedAt.seconds) {
        const dayAgo = moment().subtract(1, 'day');
        const updatedAt = moment(new Date(chat.updatedAt.seconds * 1000));
        if (updatedAt < dayAgo) setIsOlderChat(true);
        else setIsOlderChat(false);
      } else {
        setIsOlderChat(false);
      }
    }
  }, [chat]);

  return !chat ? (
    <div className="Chats" style={{ left: 0 }} {...props}>
      <div className={classes.appBarSpacer} />
      <div>&nbsp;</div>
    </div>
  ) : (
    <Box display="flex" style={{ height: '100%', width: '100%' }}>
      <div className={classes.Chats} {...props}>
        <Info
          chat={chat}
          userMode={userMode}
          setUserMode={setUserMode}
          isOlderChat={isOlderChat}
          autoStop={autoStop}
          setOpenHeader={(open) => {
            appDispatch({ type: actions.openSection, openSection: { header: open } });
          }}
          setAutoStop={setAutoStop}
          openHeader={openHeader}
        />
        <Grid container component={Paper} className={classes.chatSection}>
          <MessagesList
            chat={chat}
            showHistory={showHistory}
            setShowHistory={setShowHistory}
            oldChat={oldChat}
            allMessages={allMessages}
            setModalContent={setModalContent}
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            openHeader={openHeader}
          />
          <MessageInput
            isOlderChat={isOlderChat}
            handleSendMessage={handleSendMessage}
            sending={sending}
            chat={chat}
            chatId={chatId}
          />
        </Grid>
        <Modal
          open={modalOpen}
          onClose={handleModalClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Box display="flex" justifyContent="center">
            <div className={classes.modalPaper}>
              <ReactPanZoom
                image={modalContent}
                alt="Image alt text"
                onClick={() => {
                  const view = window.open('');
                  view.document.write(
                    `<iframe width='100%' height='100%' src='${modalContent}'></iframe>`,
                  );
                }}
              />
            </div>
          </Box>
        </Modal>
      </div>
      <CustomDFMessengerChat />
    </Box>
  );
};

const Props = {};

Chat.propTypes = Props;

export default Chat;
